import { Input } from "@babackapp/customer-ui/components/input";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@babackapp/customer-ui/components/popover";
import { ChevronsUpDown } from "lucide-react";
import React, { useState } from "react";
import { COUNTRY_LIST } from "../utils/countries";

type CountryComboboxProps = {
  value?: string;
  onChange: (iso: string) => void;
  placeholder?: string;
  label?: string;
  className?: string;
};

export function CountryCombobox({ value, onChange, placeholder = "Country", label, className }: CountryComboboxProps) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  const selectedCountry = COUNTRY_LIST.find((c) => c.iso === value);

  const filtered = query
    ? COUNTRY_LIST.filter(
        (c) =>
          c.name.toLowerCase().includes(query.toLowerCase()) ||
          c.iso.toLowerCase().includes(query.toLowerCase()),
      )
    : COUNTRY_LIST;

  const handleSelect = (iso: string) => {
    onChange(iso);
    setOpen(false);
    setQuery("");
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={`min-h-[44px] w-full flex items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm text-left transition-colors hover:bg-muted focus:outline-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 ${className ?? ""}`}
        >
          <span className={selectedCountry ? "text-foreground" : "text-muted-foreground"}>
            {selectedCountry ? `${selectedCountry.iso} — ${selectedCountry.name}` : (placeholder ?? "Select country")}
          </span>
          <ChevronsUpDown className="size-4 text-muted-foreground shrink-0 ml-2" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[280px] p-0" align="start">
        <div className="p-2 border-b border-border">
          <Input
            placeholder="Search..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            autoFocus
          />
        </div>
        <div className="max-h-60 overflow-y-auto">
          {filtered.length === 0 ? (
            <div className="px-3 py-2 text-sm text-muted-foreground">No results</div>
          ) : (
            filtered.map((country) => (
              <button
                key={country.iso}
                type="button"
                onClick={() => handleSelect(country.iso)}
                className={`w-full text-left px-3 py-2 text-sm hover:bg-accent hover:text-accent-foreground transition-colors ${value === country.iso ? "bg-accent/50 font-medium" : ""}`}
              >
                <span className="text-muted-foreground mr-2">{country.iso}</span>
                {country.name}
              </button>
            ))
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
